import { useEffect, useState } from 'react'
import Image from 'next/image'
import { styled } from '@mui/material'
import { useTranslation } from 'src/utils/i18n'
import { messageInfo } from 'src/components/Message'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

const NewProgress3 = ({ nowPage }) => {

  const { t } = useTranslation('commonAndroid')
  const [copy, setCopy] = useState(false)

  const success = () => {
    messageInfo({
      type: 'success',
      content: 'Copied'
    })
  }

  const StepProgress = ({ current = 2, total = 6 }) => {
    const barWidth = 72 // 宽度

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <>
      <StepProgress />
      <ScrollDiv className='!h-[calc(var(--vh2)*100-194px)] pb-2 mx-[30px] flex flex-col items-center overflow-auto'>

        {/* 1/2的内容 */}
        <div className={`flex flex-col items-center`}>
          <h2 className='text-[24px] smj:text-[20px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[30px]'>{t('Download Msafely installer on the target phone')}</h2>

          {/* 安装引导图：默认 Msafely 品牌图；测试等环境用 NEXT_PUBLIC_APK_QR_IMAGE 换成二维码，扫码直接下载安装包 */}
          <Image src={process.env.NEXT_PUBLIC_APK_QR_IMAGE || 'https://image.msafely.com/20231103/msafely_apk_19dbb61286.png'} width={180} height={78} className='w-[180px] h-auto mb-[12px]' alt='' />

          {/* 内容 */}
          <ul className='text-[14px] font-[400] leading-[21px]'>
            <li className='flex items-start'>
              <div className='flex items-start'>
                <p>{t('On the device you want to monitor')}:</p>
              </div>
            </li>
            <li className='flex items-start mt-5'>
              <p>1.&nbsp;&nbsp;</p>
              <p>{t('Type')} <strong>msafely.net/download </strong> {t('into the browser address bar or scan the QR code to go to the download page')}</p>
            </li>
            <li className='flex items-start mt-2'>
              <p>2.&nbsp;</p>
              <p>{t('Slide the bar from left to right to begin download')} <b>{t('Download anyway')}</b>.</p>
            </li>
            <li className='flex items-start mt-2'>
              <p>3.&nbsp;</p>
              <p>{t('Once downloaded tap')} <strong>{t('Open')}</strong>. {t("If you see a warning go to Settings find your browser app and enable Install unknown apps Then return to your browser to install")}</p>
            </li>
            <li className='flex items-start mt-2'>
              <p>4.&nbsp;</p>
              <p>{t("After installing tap")} <strong>{t('Open')}</strong>. {t('If you see a security pop-up tap')} <strong>{t('IGNORE')}</strong>.</p>
            </li>
          </ul>
        </div>
      </ScrollDiv >
    </>
  )
}

export default NewProgress3